import { render, staticRenderFns } from "./CourseContentsTemplate2.vue?vue&type=template&id=3ac23e2f&"
import script from "./CourseContentsTemplate2.vue?vue&type=script&lang=js&"
export * from "./CourseContentsTemplate2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports